import React, { useState, useMemo } from 'react';
import { DirectionsCar, Home, LocationOn, Assignment } from '@material-ui/icons';

import useConnect from './hooks';
import { usePageView } from '../../hooks/analytics';
import piwik from '../../services/analytics';
import { eventTags, BENEFIT_SELECTION } from '../../services/analytics/tags';

import Page from '../../components/Page';
import Title from '../../components/Title';
import Footer from '../../components/Footer';
import Button from '../../components/Button';
import { MultiPicker } from '../../components/Inputs';

import messages from './messages';
import { BENEFITS } from '../../enums';

const styles = {
  content: {
    flex: 1,
  },
  buttonContainerStyle: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    textTransform: 'none',
  },
  icons: {
    fontSize: '50px',
    margin: '10px 0 10px 0',
  },
  textStyle: {
    fontWeight: '500',
    fontSize: '18px',
  },
};

const BenefitSelection = () => {
  usePageView(BENEFIT_SELECTION);

  const { next } = useConnect();

  const content = useMemo(
    () => [
      { name: messages.replacementCar, value: BENEFITS.REPLACEMENT_CAR, image: DirectionsCar },
      { name: messages.returnHome, value: BENEFITS.RETURN_HOME, image: Home },
      { name: messages.reachOriginalDestination, value: BENEFITS.TRIP_CONTINUITY, image: LocationOn },
      { name: messages.other, value: BENEFITS.OTHER, image: Assignment },
    ],
    [],
  );

  const [benefit, setBenefit] = useState('');

  return (
    <Page name="benefitSelection" direction="column">
      <div style={styles.content}>
        <Title content={messages.title} src="fnolCircumstancesDetails" size={64} />
        <MultiPicker
          content={content}
          onChange={value => {
            piwik.trackEvent({
              ...eventTags.benefit_selection,
              event_label: value,
            });
            if (benefit !== value) {
              setBenefit(value);
            } else {
              setBenefit('');
            }
          }}
          buttonContainerStyle={styles.buttonContainerStyle}
          iconStyle={styles.icons}
          textStyle={styles.textStyle}
          option={6}
          selected={benefit}
        />
      </div>
      <Footer direction="column">
        <Button
          name="confirmBenefitSelection"
          content={messages.confirmBenefitSelection}
          onClick={() => {
            piwik.trackEvent({ ...eventTags.benefit_selection_confirm, event_label: benefit });
            next(benefit);
          }}
          disabled={!benefit}
        />
      </Footer>
    </Page>
  );
};

export default BenefitSelection;
